import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ApiCallServices from "../../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../../services/endpoint/endPoint";
import button from "../../../../button.module.css";
import PublishersList from "./child/PublishersList";

const Publishers = () => {
  const initialState = {
    segment_id: "",
    name: "",
    url: "",
    app: "",
    avails: "",
    display_cpm: "",
    video_cpm: "",
    ctv_cpm: "",
    geo_id: "",
    id: null,
  };

  const [geoList, setGeoList] = useState([]);

  const [segmentsList, setSegmentsList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [newPublishers, setNewPublishers] = useState(initialState);
  const [search, setSearch] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideModal1, setShowHideModal1] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  const fetchCountries = async () => {
    try {
      const res = await ApiCallServices.getlisting(
        END_POINTS.countryList + "?segmentStatus=1"
      );
      if (res.status === 200) {
        setGeoList(res.data.data);
      }
    } catch {
      toast.error("Failed to load countries");
    }
  };

  const fetchSegments = async (geo_id = "") => {
    try {
      const res = await ApiCallServices.create(END_POINTS.segmentssTableData, {
        name: "",
        geo_id,
      });
      if (res.status === 200) setSegmentsList(res.data.data);
    } catch {
      toast.error("Failed to load segments");
    }
  };

  const updateStatus = async (id, status) => {
    try {
      const res = await ApiCallServices.create(
        END_POINTS.updatePublishersStatus,
        { id, status }
      );
      if (res.status === 200) {
        toast.success(res.data.message || "Status updated");
        getPublisherssTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to update status");
    }
  };

  const getPublishers = async (id) => {
    try {
      const res = await ApiCallServices.getlisting(
        `${END_POINTS.getPublishersById}/${id}`
      );
      if (res.status === 200) {
        const publisher = res.data.data;

        // Fetch filtered segments based on geo_id first
        await fetchSegments(publisher.geo_id);

        // Then set the state
        setNewPublishers({ ...publisher });

        setIsEditMode(true);
        setShowHideModal(true);
        document.body.style = "overflow: hidden";
      }
    } catch {
      toast.error("Failed to fetch publisher details");
    }
  };

  const getPublisherssTableData = async () => {
    setLoader(true);
    const data = {
      name: search,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    try {
      const res = await ApiCallServices.create(
        END_POINTS.publisherssTableData,
        data
      );
      if (res.status === 200) setTableData(res.data.data);
    } catch (error) {
      toast.error(error.response?.data?.error || "Error fetching data");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    getPublisherssTableData();
    fetchSegments();
  }, [search, sortingColumn, sortingOrder]);

  const handleInput = async (e) => {
    const { name, value } = e.target;

    if (name === "geo_id") {
      setNewPublishers((prev) => ({
        ...prev,
        geo_id: value,
        segment_id: "", // Clear segment
      }));
      fetchSegments(value); // Filter segments by selected country
      return;
    }

    if (name === "segment_id") {
      setNewPublishers((prev) => ({
        ...prev,
        segment_id: value,
      }));

      // Auto-select geo_id if not selected
      if (!newPublishers.geo_id && value) {
        try {
          const res = await ApiCallServices.getlisting(
            `${END_POINTS.getSegmentsById}/${value}`
          );
          if (res.status === 200) {
            const geo = res.data.data.geo_id;
            setNewPublishers((prev) => ({
              ...prev,
              geo_id: geo,
            }));
            fetchSegments(geo);
          }
        } catch {
          toast.error("Failed to auto-fetch geo for selected segment");
        }
      }
      return;
    }

    setNewPublishers((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!newPublishers.segment_id) errors.segment_id = "Segment is required";
    if (!newPublishers.name) errors.name = "Name is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const endpoint = isEditMode
        ? END_POINTS.updatePublishers
        : END_POINTS.createPublishers;
      const res = await ApiCallServices.create(endpoint, newPublishers);
      if (res.status === 200) {
        toast.success(res.data.message);
        resetForm();
        getPublisherssTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Operation failed");
    }
  };

  const resetForm = () => {
    setNewPublishers(initialState);
    setIsEditMode(false);
    setShowHideModal(false);
    setErrors({});
    document.body.removeAttribute("style");
  };

  const groupSegments = (segments) => {
    const grouped = {};

    segments.forEach((seg) => {
      if (seg.parent_id === 0) {
        grouped[seg.id] = { ...seg, subsegments: [] };
      }
    });

    segments.forEach((seg) => {
      if (seg.parent_id !== 0 && grouped[seg.parent_id]) {
        grouped[seg.parent_id].subsegments.push(seg);
      }
    });

    return Object.values(grouped);
  };

  const groupedSegments = React.useMemo(
    () => groupSegments(segmentsList),
    [segmentsList]
  );

  const deletePublisher = async (id) => {
    if (!window.confirm("Are you sure you want to delete this publisher?"))
      return;

    try {
      const res = await ApiCallServices.create(
        END_POINTS.deletePublishers, 
        { id }
      );

      if (res.status === 200) {
        toast.success(res.data.message || "Publisher deleted successfully");
        getPublisherssTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to delete publisher");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage Publisher</h3>
          </div>
      </div>

        <div className="filter-wraper d-flex justify-content-between">
          <div className="form-group search-icon">
            <input
              type="text"
              className="form-control"
              placeholder="Search publishers"
              onChange={(e) =>
                setSearch(e.target.value.length > 1 ? e.target.value : "")
              }
            />
          </div>
          <button
            className={`${button.btn} ${button.btnDarkBlue}`}
            onClick={() => {
              setShowHideModal(true);
              document.body.style = "overflow: hidden";
            }}
          >
            Add New Publisher
          </button>
        </div>

        <PublishersList
          tableData={tableData}
          getPublishers={getPublishers}
          search={search}
          onSort={(col) => {
            if (col === sortingColumn) {
              setSortingOrder((prev) => (prev === "asc" ? "desc" : "asc"));
            } else {
              setSortingColumn(col);
              setSortingOrder("asc");
            }
          }}
          deletePublisher={deletePublisher}
          sortingColumn={sortingColumn}
          sortingOrder={sortingOrder}
          updateStatus={updateStatus}
          loader={loader}
          addsubPublishers={() => {}}
        />
      </div>

      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {isEditMode ? "Update Publisher" : "Create New Publisher"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={resetForm}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>
                      Geo <span className="astric">*</span>
                    </label>
                    <select
                      name="geo_id"
                      value={newPublishers.geo_id}
                      onChange={handleInput}
                      className="form-control"
                      disabled={isEditMode}
                    >
                      <option value="">Select Geo</option>
                      {geoList.map((geo) => (
                        <option key={geo.ccode} value={geo.ccode}>
                          {geo.name}
                        </option>
                      ))}
                    </select>
                    {errors.geo_id && (
                      <div className="input-error">{errors.geo_id}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Segment <span className="astric">*</span>
                    </label>
                    <select
                      name="segment_id"
                      value={newPublishers.segment_id}
                      onChange={handleInput}
                      className="form-control"
                    >
                      <option value="">Select Segment</option>
                      {groupedSegments.map((parent) => (
                        <optgroup key={parent.id} label={parent.name}>
                          {parent.subsegments.length > 0 ? (
                            parent.subsegments.map((child) => (
                              <option key={child.id} value={child.id}>
                                {child.name}
                              </option>
                            ))
                          ) : (
                            <option value={parent.id}>{parent.name}</option>
                          )}
                        </optgroup>
                      ))}
                    </select>

                    {errors.segment_id && (
                      <div className="input-error">{errors.segment_id}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Name <span className="astric">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={newPublishers.name}
                      onChange={handleInput}
                      className="form-control"
                    />
                    {errors.name && (
                      <div className="input-error">{errors.name}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      URL <span className="astric">*</span>
                    </label>
                    <input
                      type="text"
                      name="url"
                      value={newPublishers.url}
                      onChange={handleInput}
                      className="form-control"
                    />
                  </div>

                  <div className="form-group">
                    <label>App</label>
                    <input
                      type="text"
                      name="app"
                      value={newPublishers.app}
                      onChange={handleInput}
                      className="form-control"
                    />
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Avails</label>
                      <input
                        type="number"
                        name="avails"
                        value={newPublishers.avails}
                        onChange={handleInput}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Display CPM</label>
                      <input
                        type="number"
                        name="display_cpm"
                        step="0.01"
                        value={newPublishers.display_cpm}
                        onChange={handleInput}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Video CPM</label>
                      <input
                        type="number"
                        name="video_cpm"
                        step="0.01"
                        value={newPublishers.video_cpm}
                        onChange={handleInput}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>CTV CPM</label>
                      <input
                        type="number"
                        name="ctv_cpm"
                        step="0.01"
                        value={newPublishers.ctv_cpm}
                        onChange={handleInput}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className={`${showHideModal ? "overlay" : ""}`}></div>
    </>
  );
};

export default Publishers;
